import { render, staticRenderFns } from "./WindowSection.vue?vue&type=template&id=05ef8b2b&"
import script from "./WindowSection.vue?vue&type=script&lang=ts&"
export * from "./WindowSection.vue?vue&type=script&lang=ts&"
import style0 from "./WindowSection.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports